import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Header from '../Component/Header';

function ServicesDetails() {
  const { id, name } = useParams();
  const navigate = useNavigate();

  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/getproducts/category/${id}`);

        if (response.status === 404) throw new Error('No products found');

        if (!response.ok) throw new Error(`Error: ${response.status}`);

        const result = await response.json();

        if (result.message === "No products found for the given category ID") {
          setServices([]);
          setError("No records found");
        } else {
          const transformedData = result.products.map((item) => {
            let imgs = [];
            try {
              imgs = JSON.parse(item.product_image || "[]");
            } catch {}

            return {
              id: item.product_id,
              name: item.product_name,
              images: imgs,
              cover: imgs.length > 0 ? imgs[0] : ""
            };
          });

          setServices(transformedData);
          setError(null);
        }

        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchServices();
  }, [id]);

  const goToProductImages = (productId, productName) => {
    navigate(`/product/${productId}/${productName}`);
  };

  return (
    <div>
      <Header />

      <h3 className="text-center" style={{ color: '#000000ff', marginTop: '150px', fontSize: '3rem' }}>
        {name}
      </h3>

      <div className="container p-5">
        {loading ? (
          <div className="text-center">Loading...</div>
        ) : error ? (
          <div className="text-center text-danger">{error}</div>
        ) : services.length === 0 ? (
          <div className="text-center">No records found</div>
        ) : (
          <div className="row g-4">
            {services.map((service) => (
              <div className="col-18 col-md-7 col-lg-3" key={service.id}>
                <div
                  className="card p-0 shadow-sm"
                  style={{ cursor: "pointer", borderRadius: "10px" }}
                  onClick={() => goToProductImages(service.id, service.name)}
                >
                  <img
                    src={service.cover}
                    alt={service.name}
                    className="card-img-top"
                    style={{ height: "380px", objectFit: "cover" }}
                  />
                  <div className="card-body text-center">
                    <h6 className="fw-bold">{service.name}</h6> {/* PRODUCT NAME HERE */}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

      </div>
    </div>
  );
}

export default ServicesDetails;
